angular.module( 'acme.view.application.resources.modals.request', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.modals.request.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesModalsRequest = {
        name: 'application.resources.modals.request',
        url: '/resources/modals/request',
        views: {
          "main": {
            controller: 'ResourcesModalsRequestController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/resources/modals/request/request.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(resourcesModalsRequest);
});
